import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Header from '../../../common/Header';
import { APP_ROUTES } from '../../../common/constants/Routes';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import VechicelFrom from './VechicelFrom';

function VehicleView() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      vechicel_no: location.state.data?.data?.vechicel_no || '',
      vechicel_owner: location.state.data?.data?.vechicel_owner || '',
      loading_units: location.state.data?.data?.loading_units || '',
      vechicel_type: location.state.data?.data?.vechicel_type || '',
      status: location.state.data?.data?.status || '',
      lock_id: 1,
    },
  });
  const onSubmit = (data: any) => {
    console.log('Form Data:', data);
    navigate(APP_ROUTES.VEHICLE);
    // Handle form submission logic here
  };
  return (
    <div>
      <Header
        header={t('VIEW_VECHICEL')}
        route={APP_ROUTES.VEHICLE}
        buttonName={t('GO_BACK')}
        buttonIcon={SubdirectoryArrowRightIcon}
        view={true}
      />

      <VechicelFrom
        register={register}
        errors={errors}
        handleSubmit={handleSubmit}
        watch={watch}
        view={true}
        control={control}
        setValue={setValue}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default VehicleView;
